import React from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router'

import Moment from 'moment'
import _ from 'lodash'

import Alerts from './alerts.jsx'
// import AlertsGrouped from './alertsgrouped.jsx'
import AlertFilters from './alertFilters.jsx'
import HeartBeat from './widgets/heartbeat.jsx'
import Subscriptions from './subscriptions.jsx'

import AlertsWorker from "./workers/alerts.worker.js"
import ServicesWorker from "./workers/services.worker.js"

import * as API from './api'

import './client/index.css'


const ACTIVE = 1;
const PAUSED = 2;
const SNOOZED = 4;

export default class Heartbeat extends React.Component {
	static contextTypes = {
		router: PropTypes.object
	}

	constructor(props) {
		super(props);

		this.setItemStatus = this.setItemStatus.bind(this);
		this.serviceId = this.props.params ? this.props.params.serviceId : null;

		const filters = getStoredFilters();

		this.state = {
			showPanel: "alerts",
			alerts: {},
			services: {},
			awayItems: [],
			subscriptionsDialogOpen: false,
			// currentService: "",
			// useSmokeScreen: true, // Filters long running services from the alert list
			filters,
		}
	}

	componentDidMount() {
		// Alerts
		this.alertsWorker = new AlertsWorker();
		this.alertsWorker.onmessage = e => {
			this.setState({ alerts: e.data });
		}

		// Services
		this.servicesWorker = new ServicesWorker();
		this.servicesWorker.onmessage = e => {
			this.setState(e.data);
		}

		// if(this.serviceId) {
		// 	API.fetchService(this.serviceId).then(response => {
		// 		this.setState({ currentService: response.server });
		// 	});
		// }
	}

	componentWillReceiveProps(nextProps) {
		// if(nextProps.params && nextProps.params.serviceId !== this.serviceId) {
		// 	this.serviceId = nextProps.params.serviceId;
		// 	if(this.serviceId) {
		// 		API.fetchService(this.serviceId).then(response => {
		// 			this.setState({ currentService: response.server });
		// 		});
		// 	}
		// 	else {
		// 		this.setState({ currentService: "" });
		// 	}

		// }
	}

	componentDidUpdate() {
		const alertItems = filterData(this.state.alerts, this.state.filters);
		document.title = `Heartbeat - ${alertItems.numberOfItems || 0} alert${alertItems.numberOfItems === 1 ? "" : "s"}`;
	}

	componentWillUnmount() {
		if (this.alertsWorker) {
			this.alertsWorker.terminate();
		}

		if (this.servicesWorker) {
			this.servicesWorker.terminate();
		}

		// this.setState({ currentService: "" });
	}

	setItemStatus(id, type) {

		// Find service item
		let store = "alerts";
		let index = this.state[store].items.findIndex(i => i.id === id);
		if(index === -1) {
			store = "services";
			index = this.state[store].items.findIndex(i => i.id === id);
		}

		const item = this.state[store].items[index];
		const newItem = {
			...item,
			snoozedUntil: getSnoozedUntil(type),
			status: getStatus(type),
		}

		// Shall we remove the item fron alerts and update the counts?
		const items = [...this.state[store].items];

		if(type !== "active" && store === "alerts") {
			items.splice(index, 1);
			const serviceItems = this.state.services.items;

			this.setState({
				alerts: {
					items,
					numberOfItems: items.length,
				},
				services: {
					items: [newItem, ...serviceItems],
					numberOfItems: serviceItems.length + 1,
				}
			});

		}
		else if(type === "active" && store === "services") {
			items.splice(index, 1);
			const alertItems = this.state.alerts.items;

			this.setState({
				services: {
					items,
					numberOfItems: items.length,
				},
				alerts: {
					items: [newItem, ...alertItems],
					numberOfItems: alertItems.length + 1,
				}
			});
		}
		else {
			items.splice(index, 1, newItem);
			this.setState({
				[store]: {
					items,
					numberOfItems: items.length,
				}
			});
		}
	}

	handleActionClick(id, selfUrl, type) {
		const method = (type === "onhold" || type === "active") ? API.setAlertStatus : API.snoozeService;
		method(selfUrl, type).then(response => {
			this.setItemStatus(id, type);
		});
	}

	handleComment(id, selfUrl, comment) {
		API.setComment(selfUrl, comment).then(response => {
			const stores = ["alerts", "services"];
			stores.forEach((store) => {
				let index = this.state[store].items.findIndex(i => i.id === id);
				if(index === -1) {
					return;
				}

				const item = this.state[store].items[index];

				const newItem = {
					...item,
					message: comment,
					messageCreated: Moment().toISOString(true),
				};

				const items = [...this.state[store].items];
				items.splice(index, 1, newItem);
				this.setState({
					[store]: {
						items,
						numberOfItems: items.length,
					}
				});
			})
		});
	}

	handleShowPanelClick(showPanel) {
		this.setState({
			showPanel,
			// useSmokeScreen: showPanel === "alerts" && this.state.showPanel === showPanel ? !this.state.useSmokeScreen : true,
		});
	}

	toggleServer = (server) => {
		const ignoredServers = [...this.state.filters.ignoredServers];
		const index = ignoredServers.indexOf(server);
		if (index >= 0) {
			ignoredServers.splice(index, 1);
		} else {
			ignoredServers.push(server);
		}

		const newFilters = { ...this.state.filters, ignoredServers };
		this.setState({ filters: newFilters }, () => {
			storeFilters(newFilters);
		});
	}

	ignoreNoServers = () => {
		const ignoredServers = [];
		const newFilters = { ...this.state.filters, ignoredServers };
		this.setState({ filters: newFilters }, () => {
			storeFilters(newFilters);
		});
	}

	ignoreAllServers = () => {
		const services = this.state.services;
		const ignoredServers = getAvailableServers(services.items);
		const newFilters = { ...this.state.filters, ignoredServers };
		this.setState({ filters: newFilters }, () => {
			storeFilters(newFilters);
		});
	}

	setSearch = (search) => {
		const newFilters = { ...this.state.filters, search };
		this.setState({ filters: newFilters }, () => {
			storeFilters(newFilters);
		});
	}

	toggleGroupAlerts = () => {
		const newFilters = { ...this.state.filters, groupAlerts: !this.state.filters.groupAlerts };
		this.setState({ filters: newFilters }, () => {
			storeFilters(newFilters);
		});
	}

	render() {
		const {
			showPanel,
			services,
			alerts,
			// currentService,
			// useSmokeScreen,
			filters,
		} = this.state;
		
		const serviceItems = filterItems(services.items, filters);
		const activeServiceItems = _.filter(serviceItems, item => (item.status.id === ACTIVE));
		const pausedServiceItems = _.filter(serviceItems, item => (item.status.id === PAUSED));
		const snoozedServiceItems = _.filter(serviceItems, item => (item.status.id === SNOOZED));

		let alertItems = filterData(alerts, filters);
		// if (useSmokeScreen) {
		// 	alertItems = smokeScreenFilterData(alertItems);
		// }

		let panels;
		let data;
		let groupedData;
		const groupData = showPanel !== "alerts" || filters.groupAlerts;
		switch(showPanel) {
			case "snoozed":
				if (groupData) {
					const groupedItems = _.groupBy(snoozedServiceItems, 'customer');
					groupedData = {numberOfItems: snoozedServiceItems.length, items: groupedItems};
				} else {
					data = snoozedServiceItems;
				}
				panels = (
					<Alerts
						type="snoozed"
						data={data}
						groupedData={groupedData}
						handleClick={this.handleActionClick.bind(this)}
						handleComment={this.handleComment.bind(this)}
						search={filters.search}
						selectedServiceId={this.props.params.serviceId}
					/>
				);
				break;
			case "paused":
				if (groupData) {
					const groupedItems = _.groupBy(pausedServiceItems, 'customer');
					groupedData = {numberOfItems: pausedServiceItems.length, items: groupedItems};
				} else {
					data = pausedServiceItems;
				}
				panels = (
					<Alerts
						type="paused"
						data={data}
						groupedData={groupedData}
						handleClick={this.handleActionClick.bind(this)}
						handleComment={this.handleComment.bind(this)}
						search={filters.search}
						selectedServiceId={this.props.params.serviceId}
					/>
				);
				break;
			case "active":
				if (groupData) {
					const groupedItems = _.groupBy(activeServiceItems, 'customer');
					groupedData = {numberOfItems: activeServiceItems.length, items: groupedItems};
				} else {
					data = {numberOfItems: activeServiceItems.length, items: activeServiceItems};
				}
				panels = (
					<Alerts
						type="active"
						data={data}
						groupedData={groupedData}
						handleClick={this.handleActionClick.bind(this)}
						handleComment={this.handleComment.bind(this)}
						search={filters.search}
						selectedServiceId={this.props.params.serviceId}
					/>
				);
				break;
			default:
				if (groupData) {
					const groupedItems = _.groupBy(alertItems.items, 'customer');
					groupedData = {numberOfItems: alertItems.numberOfItems, items: groupedItems};
				} else {
					data = alertItems;
				}
				panels = (
					<Alerts
						type="alert"
						data={data}
						groupedData={groupedData}
						handleClick={this.handleActionClick.bind(this)}
						handleComment={this.handleComment.bind(this)}
						search={filters.search}
						selectedServiceId={this.props.params.serviceId}
						defaultDetailsOpen={true}
					/>
				);
		}

		// const serviceHeading = currentService ? <div className="information">{currentService}</div> : null;

		return (
			<main>
				<div className="controls-alert">
					<HeartBeat show="alerts" active={showPanel} noItems={alertItems.numberOfItems} onClick={this.handleShowPanelClick.bind(this, "alerts")} /*label={useSmokeScreen ? "" : " (Unfiltered)"} onClick={this.handleShowPanelClick.bind(this, "alerts")} */ />
					<HeartBeat show="active" active={showPanel} noItems={activeServiceItems.length} onClick={this.handleShowPanelClick.bind(this, "active")} />
					<HeartBeat show="snoozed" active={showPanel} noItems={snoozedServiceItems.length} onClick={this.handleShowPanelClick.bind(this, "snoozed")} />
					<HeartBeat show="paused" active={showPanel} noItems={pausedServiceItems.length} onClick={this.handleShowPanelClick.bind(this, "paused")} />	
				</div>

				<AlertFilters
					availableServers={getAvailableServers(services.items)}
					ignoredServers={filters.ignoredServers}
					toggleServer={this.toggleServer}
					ignoreNoServers={this.ignoreNoServers}
					ignoreAllServers={this.ignoreAllServers}
					search={filters.search}
					setSearch={this.setSearch}
					groupAlerts={filters.groupAlerts}
					toggleGroupAlerts={this.toggleGroupAlerts}
					displayGroupAlerts={showPanel === "alerts"}
					onSubscriptionsClick={() => this.setState({ subscriptionsDialogOpen: true })}
				/>

				{panels}
				{this.props.children || <div className="center dim">Click on an item to see more details</div>}


				<Subscriptions
					dialogOpen={this.state.subscriptionsDialogOpen}
					alerts={this.state.alerts}
					onClose={() => this.setState({ subscriptionsDialogOpen: false })}
					ignoredServers={filters.ignoredServers}
				/>

				{/* <div className="controls-errors"> */}
					{/* {serviceHeading} */}
					{/* <Link className="sentry" to="/sentry/" activeClassName="sel">Sentry</Link> */}
					{/* <Link className="errors" to="/errors/" activeClassName="sel">All errors</Link> */}
					{/* <Link className="logs" to="/logs/" activeClassName="sel">All logs</Link> */}
				{/* </div> */}
			</main>
	    );
	}
};
// <HelpScout show="unassigned" />

// HELPERS
function getStatus(type) {
	let status = {};
	// let snoozedUntil = "";
	switch(type) {
		case "onhold":
			status.id = PAUSED;
			break;
		case "active":
			status.id = ACTIVE;
			break;
		default:
			status.id = SNOOZED;
			break;
	}

	return status;
}

function getSnoozedUntil(type) {
	if(type === "onhold" || type === "active") {
		return "";
	}

	const duration = Moment.duration(type);
	return Moment().add(duration).toISOString(true);
}

// Hide items until we're sure there's a problem and not just a long running operation (https://3.basecamp.com/3091592/buckets/29647/todos/47982912)
// function smokeScreenFilterData(data) {
// 	if(!data || !data.items) {
// 		return {
// 			items: null,
// 			numberOfItems: null,
// 		};
// 	}

// 	const items = data.items.filter(item => {
// 		if(!item.interval) {
// 			return true;
// 		}

// 		const lastRun = Moment(item.lastRun);
// 		let unit = item.intervalUnit.trim();
// 		unit = unit === "mm" ? "M" : unit;
// 		const duration = Moment.duration(item.interval, unit);
// 		const durationMinutes = duration.asMinutes();

// 		let smokeDelay = 0;

// 		// < 15 minuter dvs jobb som körs med 15 minuters intervall än tätare
// 		// De dyker inte upp alls i Heartbeats lista förrän de legat nere mer än 20 minuter. De kan börja blinka efter 35 minuter.
// 		// På så sätt har de jobb som körs var 15 minut två cykler på sig innan de börjar blinka och det finns en cykel för dem innan de dyker upp i listan. Borde bli bra.
// 		if(durationMinutes < 15) {
// 			smokeDelay = 15 + 20;
// 		}

// 		// 15-60 minuter får 35 minuter på sig att dyka upp i listan och 65 minuter på sig innan de börjar blinka.
// 		else if (durationMinutes >= 15 && durationMinutes <= 60) {
// 			smokeDelay = durationMinutes + 35;
// 		}

// 		// >60 minuter får 65 minuter på sig att dyka upp i listan och kan börja blinka direkt eftersom de då har haft 65 minuter på sig att köra klart och inget jobb ska behöva ta så lång tid.
// 		// Vi vill ju heller inte ha för lång tid så att vi missar en varning precis innan vi går hem för kvällen.
// 		else {
// 			smokeDelay = durationMinutes + 65;
// 		}

// 		// If the job is reporting in as running, let it go for double the smokescreen duration before we show it in the filtered alert list
// 		if(item.running) {
// 			smokeDelay = smokeDelay * 2;
// 		}

// 		return !lastRun.isAfter(Moment().subtract(smokeDelay, "minutes"));
// 	});

// 	return {
// 		items,
// 		numberOfItems: items.length,

// 	}
// }

function filterData(data, filters) {
	if (!data || !data.items) {
		return {
			items: null,
			numberOfItems: null,
		};
	}

	const items = filterItems(data.items, filters);

	return {
		items,
		numberOfItems: items.length,
	};
}

function filterItems(items, filters) {
	const { search, ignoredServers } = filters;

	let filteredItems = items || [];
	if (search) {
		const searchLower = search.toLowerCase();
		filteredItems = filteredItems.filter(item => {
			return (
				(item.name || "").toLowerCase().includes(searchLower)
				|| (item.server || "").toLowerCase().includes(searchLower)
				|| (item.windowsServiceDisplayName || "").toLowerCase().includes(searchLower)
			);
		});
	}

	if (ignoredServers.length > 0) {
		filteredItems = filteredItems.filter(item => !ignoredServers.includes(item.server));
	}

	// Sort by priority, then by lastRun
	filteredItems = _.orderBy(filteredItems, item => item.lastRun, "desc");
	filteredItems = _.orderBy(filteredItems, item => item.priority, "desc");

	return filteredItems;
}


function getAvailableServers(services) {
	const availableServers = [];
	(services || []).forEach(s => {
		if (
			!(s.server && s.server.startsWith("RD"))
			&& !availableServers.includes(s.server)
		) {
			availableServers.push(s.server);
		}
	});
	return availableServers.sort((a, b) => a.localeCompare(b));
}

const storageKey = "filters";
function getStoredFilters() {
	const defaultFilters = {
		ignoredServers: [],
		search: "",
		groupAlerts: false,
	};
	try {
		const stored = localStorage.getItem(storageKey);
		const filters = JSON.parse(stored);
		return filters || defaultFilters;
	} catch (e) {
		console.log("Something went wrong when reading saved filters.");
		console.error(e);
		localStorage.removeItem(storageKey);
		return defaultFilters;
	}
}

function storeFilters(filters) {
	localStorage.setItem(storageKey, JSON.stringify(filters));
}



// WEBPACK FOOTER //
// ./src/main.jsx